import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import RoutePending from './components/utils/RoutePending/RoutePending'

export function getRouter() {
    const router = createRouter({
        routeTree,
        scrollRestoration: true,
        // Per-route-match pending state (e.g. navigating between pages) is
        // resolved against these router-level defaults, not the root route's
        // own `pendingComponent` — see @tanstack/router-core's Match.js.
        defaultPendingComponent: RoutePending,
        defaultPendingMs: 200,
        defaultPendingMinMs: 150,
    })

    return router
}